import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Details from './Details';
import Section from '../Section';
import { joinPath } from 'utils/path';
function OtherActivities({ className, editPath, language, otherActivities }) {
  const location = useLocation();
  
  const otherActivitiesData = useMemo(() => otherActivities[language], [otherActivities, language]);
  const path = useMemo(() => {
    return editPath ? joinPath(editPath, 'other-activities') : '';
  }, [editPath]);

  const editPathState = useMemo(() => ({ background: location }), [location]);

  return (
    <Section className={className} editPath={path} editPathState={editPathState} title="title.otherActivities">
      {/* Boolean conversion needed to avoid displaying "0" when length is 0 */}
      {!!(otherActivitiesData && otherActivitiesData.length) && (
        <Details otherActivities={otherActivitiesData} />
      )}
    </Section>
  );
}

OtherActivities.propTypes = {
  className: PropTypes.string,
  editPath: PropTypes.string,
  language: PropTypes.string.isRequired,
  otherActivities: PropTypes.object.isRequired
};

export default OtherActivities;
